import { Button, Form } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import type { PendingIncomeRow } from '@econtractor/types';
import { ProductTitle } from 'modules/product';
import { UserNameItem } from 'modules/user';
import CountBadge from '../../CounBadge';
import OperationWarehouse from '../../OffWarehouseOperations/OperationItems/OperationWarehouse';

interface PendingIncomeTableRowProps {
    row: PendingIncomeRow;
    canAct: boolean;
    checked: boolean;
    saving: boolean;
    onToggle: (operationId: number) => void;
    onAcceptAll: (operationId: number) => void;
    onAcceptPartial: (row: PendingIncomeRow) => void;
}

const PendingIncomeTableRow = ({
    row,
    canAct,
    checked,
    saving,
    onToggle,
    onAcceptAll,
    onAcceptPartial,
}: PendingIncomeTableRowProps) => {
    const { t } = useTranslation(['Warehouses']);

    return (
        <tr>
            {canAct ? (
                <td className="check">
                    <Form.Check
                        type="checkbox"
                        checked={checked}
                        disabled={saving}
                        onChange={() => onToggle(row.ID)}
                        aria-label={t('pendingIncome.acceptColumn')}
                    />
                </td>
            ) : null}
            <td className="username">
                <UserNameItem
                    smallMode
                    user={{
                        userName: row.userName,
                        userEmail: row.userEmail,
                        userPicture: row.userPicture || undefined,
                    }}
                />
            </td>
            <td className="warehouse text-truncate">
                <OperationWarehouse operation={row} />
            </td>
            <td className="name">
                <ProductTitle
                    product={{
                        ID: row.productId,
                        prodName: row.prodName,
                        prodPhoto: row.prodPhoto || undefined,
                        prodArticle: row.prodArticle,
                        vendorName: row.vendorName,
                    }}
                />
            </td>
            <td className="count">
                <CountBadge fs={12} count={Number(row.operCount || 0)} />
            </td>
            {canAct ? (
                <td className="accept">
                    <div className="d-flex gap-1">
                        <Button
                            size="sm"
                            className="pending-income-accept-btn"
                            variant="success"
                            disabled={saving}
                            onClick={() => onAcceptAll(row.ID)}
                        >
                            {t('pendingIncome.acceptAll')}
                        </Button>
                        <Button
                            size="sm"
                            className="pending-income-accept-btn"
                            variant="outline-primary"
                            disabled={saving || Number(row.operCount) <= 1}
                            onClick={() => onAcceptPartial(row)}
                        >
                            {t('pendingIncome.acceptPartial')}
                        </Button>
                    </div>
                </td>
            ) : null}
        </tr>
    );
};

export default PendingIncomeTableRow;
